import { Box } from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { SEARCH_POPOVER_Z_INDEX } from '../constants'

const StyledOverlay = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.4;
  z-index: ${SEARCH_POPOVER_Z_INDEX};
  ${s({ bgcolor: 'colorBlack100' })}
`

type Props = {
  setIsSearchOpen: (open: boolean) => void
}

export const Overlay: FC<Props> = ({ setIsSearchOpen }) => {
  return (
    <StyledOverlay
      onClick={() => setIsSearchOpen(false)}
      data-testid="nav-search-overlay"
    />
  )
}
